// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"7b08a473","787":"0444fbb8"}[chunkId] + ".chunk.js";
};